/**
 * TopperSelect announcement bar — mobiele pijlnavigatie (Horizon theme).
 * Zonder JS blijft de balk gewoon swipebaar via native scroll snap.
 * Init per section-instance; cleanup via AbortController.
 */
class TsAnnouncement extends HTMLElement {
  #abort = null;

  connectedCallback() {
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    this.viewport = this.querySelector('[data-ab-viewport]');
    this.prevBtn = this.querySelector('[data-ab-prev]');
    this.nextBtn = this.querySelector('[data-ab-next]');
    if (!this.viewport) return;

    this.prevBtn?.addEventListener('click', () => this.#step(-1), { signal });
    this.nextBtn?.addEventListener('click', () => this.#step(1), { signal });
    this.viewport.addEventListener('scroll', () => this.#update(), { passive: true, signal });
    window.addEventListener('resize', () => this.#update(), { signal });

    this.#update();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#abort = null;
  }

  #motion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  #step(direction) {
    this.viewport.scrollBy({ left: direction * this.viewport.clientWidth, behavior: this.#motion() });
  }

  #update() {
    const el = this.viewport;
    const atStart = el.scrollLeft <= 4;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
    // Verbergen in plaats van disablen houdt de balk visueel rustig,
    // inert haalt ze ook uit de tabvolgorde.
    this.prevBtn?.toggleAttribute('data-hidden', atStart);
    this.nextBtn?.toggleAttribute('data-hidden', atEnd);
    if (this.prevBtn) this.prevBtn.inert = atStart;
    if (this.nextBtn) this.nextBtn.inert = atEnd;
  }
}

if (!customElements.get('ts-announcement')) {
  customElements.define('ts-announcement', TsAnnouncement);
}
